import { SocialSignInButton } from '@jusbrasil-web/shared-social-sign-in'

import { ENTITY_NOTICE_GOOGLE_BUTTON_TEXT } from '../../experiments/entity-notice-fakedoor'
import styles from './entity-notice-google-button.module.scss'

export interface EntityNoticeGoogleButtonProps {
  kind: 'primary' | 'secondary'
  appId?: string
  featureCode?: string
  fromComponent?: string
  nextUrl?: string
}

/**
 * `SocialSignInButton` takes a `kind` of `'primary' | 'tertiary'`, so this
 * wrapper forwards the state's kind to the design system — which also gives
 * the Google logo its white badge on the primary look.
 *
 * `signupData` is intentionally never passed here — the phone must never
 * become a query param on the Google-callback URL this component builds
 * (Invariante — see entity-notice-entry.tsx). Omitting the prop entirely,
 * the same way `EmailSignIn` already does for its own Google button, is
 * simpler and safer than passing an always-empty `whatsApp` field.
 */
export function EntityNoticeGoogleButton({
  kind,
  appId,
  featureCode,
  fromComponent,
  nextUrl,
}: EntityNoticeGoogleButtonProps) {
  return (
    <div className={`${styles.root} ${kind === 'primary' ? styles.primary : styles.secondary}`}>
      <SocialSignInButton
        provider="google"
        kind={kind === 'primary' ? 'primary' : 'tertiary'}
        appId={appId ?? ''}
        featureCode={featureCode ?? ''}
        fromComponent={fromComponent ?? 'EntityNoticeEntry'}
        nextUrl={nextUrl ?? ''}
        minHeight={48}
      >
        {ENTITY_NOTICE_GOOGLE_BUTTON_TEXT}
      </SocialSignInButton>
    </div>
  )
}
